import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useSurveyForSettingsQueryKey } from './useSurveyForSettingsQueryKey'

export const useInvalidateSurveyForSettingsQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useSurveyForSettingsQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
